import meta from './defaultMeta';

export default [
	{
		path: 'resume/:appId?',
		name: 'ResumeByAppId',
		component: () => import(/* webpackChunkName: "Resume" */ '@/views/Resume'),
		meta: {
			backButton: {
				clientWebsite: true
			},
			overflow: false,
			resetState: true,
			forceNavigation: true,
			bypassEnforcer: true,
			bypassAudit: true,
			allowGlia: false
		}
	},
	{
		path: ':productType/address/current',
		name: 'CurrentAddress',
		component: () => import(/* webpackChunkName: "CurrentAddress" */ '@/views/CurrentAddress'),
		meta: {
			...meta(),
			leavingModal: true
		}
	},
	{
		path: ':productType/authentication',
		name: 'Authentication',
		component: () => import(/* webpackChunkName: "Authentication" */ '@/views/Authentication'),
		meta: {
			backButton: {
				clientWebsite: true
			},
			overflow: false,
			resetState: true,
			forceNavigation: true,
			bypassEnforcer: true,
			showFooter: true,
			allowGlia: false
		}
	},
	{
		path: ':productType/employment/current',
		name: 'CurrentEmployment',
		component: () => import(/* webpackChunkName: "CurrentEmployment" */ '@/views/CurrentEmployment'),
		meta: {
			...meta(),
			leavingModal: true
		}
	},
	{
		path: ':productType/identification',
		name: 'Identification',
		component: () => import(/* webpackChunkName: "Identification" */ '@/views/Identification'),
		meta: { ...meta() }
	},
	{
		path: ':productType/disclosures',
		name: 'Disclosures',
		component: () => import(/* webpackChunkName: "Disclosures" */ '@/views/Disclosures'),
		meta: { ...meta() }
	},
	{
		path: ':productType/verify',
		name: 'Verify',
		component: () => import(/* webpackChunkName: "Verify" */ '@/views/Verify'),
		meta: {
			...meta(),
			forceNavigation: true
		}
	},
	{
		path: ':productType/documentVerification',
		name: 'DocumentVerification',
		component: () => import(/* webpackChunkName: "DocumentVerification" */ '@/views/DocumentVerification'),
		meta: {
			...meta(),
			showBackButton: false
		}
	},
	{
		path: ':productType/vehicleCollateral',
		name: 'VehicleCollateral',
		component: () => import(/* webpackChunkName: "VehicleCollateral" */ '@/views/VehicleCollateral'),
		meta: {
			...meta()
		}
	},
	{
		path: ':productType/coborrowerSelect',
		name: 'CoborrowerSelect',
		component: () => import(/* webpackChunkName: "CoborrowerSelect" */ '@/views/CoborrowerSelect.vue'),
		meta: {
			...meta()
		}
	},
	{
		path: ':productType/smsOptIn',
		name: 'SmsOptIn',
		component: () => import(/* webpackChunkName: "SmsOptIn" */ '@/views/SmsOptIn.vue'),
		meta: {
			...meta()
		}
	}
];
